import { useMemo } from 'react';
import { useAppContext } from '../../context/AppContext';
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    Legend,
    Cell,
} from 'recharts';

export default function ExpensesByCategoryChart() {
    const { expenses } = useAppContext();

    const data = useMemo(() => {
        const fixedExpenses = expenses.filter(e => e.type === 'fixa').reduce((sum, e) => sum + e.amount, 0);
        const variableExpenses = expenses.filter(e => e.type === 'variavel').reduce((sum, e) => sum + e.amount, 0);

        return [
            { category: 'Despesas Fixas', value: fixedExpenses, color: '#dc3545' },
            { category: 'Despesas Variáveis', value: variableExpenses, color: '#fd7e14' },
        ];
    }, [expenses]);

    const totalExpenses = data.reduce((sum, item) => sum + item.value, 0);

    if (totalExpenses === 0) {
        return (
            <div className="card shadow-sm mb-4">
                <div className="card-body">
                    <h2 className="h6 mb-2">Despesas por Categoria</h2>
                    <p className="text-muted small mb-0">
                        Lance despesas para visualizar a distribuição.
                    </p>
                </div>
            </div>
        );
    }

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            const percent = ((data.value / totalExpenses) * 100).toFixed(1);
            return (
                <div className="bg-white border rounded p-2 shadow-sm" style={{ fontSize: '0.875rem' }}>
                    <div className="fw-bold">{data.category}</div>
                    <div className="text-muted">
                        R$ {data.value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} ({percent}%)
                    </div>
                </div>
            );
        }
        return null;
    };

    return (
        <div className="card shadow-sm mb-4">
            <div className="card-body">
                <h2 className="h6 mb-3">Despesas por Categoria</h2>
                <div className="mb-3">
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="text-muted small">Total de Despesas:</span>
                        <span className="fw-bold">
                            R$ {totalExpenses.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                        </span>
                    </div>
                </div>
                <div style={{ width: '100%', height: 250 }}>
                    <ResponsiveContainer>
                        <BarChart data={data}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="category" />
                            <YAxis />
                            <Tooltip content={<CustomTooltip />} />
                            <Legend />
                            <Bar dataKey="value" name="Valor (R$)">
                                {data.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={entry.color} />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </div>
    );
}
